import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_TRANSLATION } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'Translation',
        name: 'Translation',
        icon: 'fas fa-language'
    },
    {
        parent: 'General.Translation',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_TRANSLATION.INDEX }
    },
    {
        parent: 'General.Translation',
        key: 'Export',
        name: 'Import / Export',
        icon: 'fas fa-file-import',
        route: { name: ROUTE_NAME_TRANSLATION.EXPORT }
    }
]);

export default registerRouteForModule(router);
